import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import SERVERCARE1 from '../../../Componet/ServerCare/SERVERCARE1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function ServerCareHePage() {
    return (
        <div className="server-care-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - ניהול שרתים</title>
                <meta
                    name="description"
                    content="ניהול שרתים לעסקים שצריכים יציבות, אבטחה, ניטור רציף, תחזוקה שוטפת, גיבוי ושחזור עם ניהול פרואקטיבי של סביבת השרתים."
                />
                <meta
                    name="keywords"
                    content="ניהול שרתים, managed server administration, Linux server management, Windows server support, patching, backup, recovery, uptime"
                />
                <meta property="og:title" content="EpicFinal - ניהול שרתים" />
                <meta
                    property="og:description"
                    content="ניהול שרתים פרואקטיבי, ניטור 24/7, תחזוקה, אבטחה וגיבוי לעסקים שצריכים סביבת שרתים יציבה ואמינה יותר."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/managed_service" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - ניהול שרתים" />
                <meta
                    name="twitter:description"
                    content="ניהול שרתים לעסקים שצריכים יציבות, אבטחה ושקט תפעולי."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"ניהול שרתים"} />
            <div className="page-content">
                <SERVERCARE1 />
                <ConsultingForm
                    language="he"
                    formId="epic-servercare-form"
                    conversionSendTo="AW-11461100984/pOYHCITHnZgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו מה קורה בשרתים שלכם"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לניהול הסביבה שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default ServerCareHePage

